import { DvToolbarAction } from '@devinco/ui/grid';
import { Injectable, inject } from '@angular/core';
import {
  ColumnType,
  alphaNumericSortNumbersFirst,
} from '@features/vt-grid/grid-options/column-types';
import { ToolbarActionsService } from '@features/vt-grid/services/toolbar-actions.service';
import { UserDto } from '@shared/interfaces/user.model';
import VoltageUtils from '@shared/utils/voltage.utils';
import { ColDef } from 'ag-grid-community';
import { getStandardActionPreset } from '@features/vt-grid/presets/preset-actions';

@Injectable({
  providedIn: 'root',
})
export class UserGridService {
  private toolbarActionService = inject(ToolbarActionsService);

  colDefs: ColDef<UserDto>[] = [
    { field: 'UserID', hide: true, type: [ColumnType.Id] },
    {
      field: 'Username',
      headerName: 'User.Username',
      type: [ColumnType.Text],
    },
    {
      field: 'UserDescription',
      headerName: 'User.Description',
      type: [ColumnType.Text],
    },
    {
      field: 'Mobile',
      headerName: 'User.Mobile',
      type: [ColumnType.NumberText],
    },
    {
      field: 'Roles',
      headerName: 'User.Roles',
      type: [ColumnType.Text],
    },
    {
      field: 'DepartmentDescription',
      headerName: 'User.Department',
      type: [ColumnType.Text],
      cellClass: ({ data }) =>
        data?.DepartmentDeleted ? 'vt-deleted-row' : '',
    },
    {
      field: 'DeviceLastLogin',
      headerName: 'User.DeviceLastLogin',
      type: [ColumnType.DateTime],
    },
    {
      field: 'EmployeeIDText',
      headerName: 'User.EmployeeID',
      type: [ColumnType.NumberText],
      comparator: alphaNumericSortNumbersFirst,
      sort: 'desc',
      hide: true,
    },
    {
      field: 'DepartmentIDText',
      headerName: 'User.DepartmentNumber',
      type: [ColumnType.Text],
      hide: true,
    },
    {
      field: 'Tags',
      headerName: 'User.Tags',
      hide: true,
      type: [ColumnType.Text],
    },
    {
      field: 'KeyfobSerial',
      headerName: 'User.KeyfobSerial',
      type: [ColumnType.NumberText],
      hide: true,
    },
    {
      field: 'KeyFobBatteryVoltage',
      headerName: 'User.KeyfobBattery',
      type: [ColumnType.Number],
      hide: true,
      width: 100,
      cellStyle: ({ value }) => {
        return VoltageUtils.setCellColor(value);
      },
      valueFormatter: formatterParams => {
        return VoltageUtils.voltageValueFormatter(formatterParams);
      },
    },
    {
      field: 'KeyFobLastSeen',
      headerName: 'User.KeyfobLastseen',
      type: [ColumnType.DateTime],
      hide: true,
    },
    {
      field: 'CardSerial',
      headerName: 'User.CardSerial',
      type: [ColumnType.Text],
      hide: true,
    },
    {
      field: 'Permissions',
      headerName: 'User.Permissions',
      type: [ColumnType.Text],
      hide: true,
    },
    {
      field: 'AllowDepartments',
      headerName: 'User.AllowDepartments',
      type: [ColumnType.Text],
      hide: true,
    },
    {
      field: 'UserStatusTranslationKey',
      headerName: 'User.UserStatus',
      type: [ColumnType.UserStatus],
      hide: true,
    },
    { field: 'DepartmentDeleted', type: ColumnType.Invisible },
  ];

  getGridActions(
    onSendLoginInformationClick: () => void,
    onEditClick: () => void
  ): DvToolbarAction[] {
    const { deleteSelectedRow } = this.toolbarActionService;
    return [
      ...getStandardActionPreset(),
      {},
      {
        icon: 'email',
        iconFont: 'material-icons-outlined',
        clickFn: onSendLoginInformationClick,
        disabled: true,
        tooltipKey: 'Grid.SendLogin',
      },
      {
        icon: 'delete',
        clickFn: deleteSelectedRow,
        disabled: true,
        tooltipKey: 'Grid.Delete',
      },
      {
        icon: 'edit',
        clickFn: onEditClick,
        disabled: true,
        tooltipKey: 'Grid.Edit',
      },
    ];
  }
}
